import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9ba9990"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "filterTrigger" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "a-label" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "o-datePicker"
}
const _hoisted_6 = { class: "o-datePicker__dates" }
const _hoisted_7 = { class: "a-label" }
const _hoisted_8 = ["readonly"]
const _hoisted_9 = { class: "a-label" }
const _hoisted_10 = ["readonly"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "o-datePicker__calendar" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "calendar-app" })
], -1))
const _hoisted_12 = { class: "a-filterList" }
const _hoisted_13 = ["name", "value", "checked", "onChange"]
const _hoisted_14 = {
  key: 0,
  class: "m-blockNotice"
}
const _hoisted_15 = { class: "a-filterList" }
const _hoisted_16 = ["name", "value", "checked", "onChange"]
const _hoisted_17 = ["name", "value", "checked", "onChange"]
const _hoisted_18 = {
  key: 0,
  class: "m-blockNotice"
}
const _hoisted_19 = {
  key: 0,
  class: "m-blockNotice"
}
const _hoisted_20 = {
  key: 1,
  class: "a-filterList -has-dropdown"
}
const _hoisted_21 = ["name", "value", "checked", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")!
  const _component_TabsComponent = _resolveComponent("TabsComponent")!
  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "a-btnCta -action",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal()))
    }, [
      _createVNode(_component_icon_component, {
        "icon-id": _ctx.IconName.Filter,
        class: "a-btnIcon"
      }, null, 8, ["icon-id"]),
      _withDirectives(_createElementVNode("span", null, null, 512), [
        [_directive_translate, { key: _ctx.Translation.Filter_trigger }]
      ])
    ]),
    (_ctx.filters)
      ? _withDirectives((_openBlock(), _createBlock(_component_ModalComponent, {
          hasHeader: false,
          isStickyOnMobile: true,
          key: _ctx.modalKey,
          onCloseModal: _ctx.closeModal
        }, {
          body: _withCtx(() => [
            _createVNode(_component_TabsComponent, {
              tabs: _ctx.getTabConfiguration(),
              initialTab: _ctx.initialTab,
              modifier: _ctx.modifier,
              onCloseAndSave: _ctx.closeAndSave,
              onTabSwitched: _ctx.tabSwitched,
              onActiveTabChange: _ctx.handleActiveTabChange
            }, _createSlots({
              [_ctx.tabHeadSlotName(_ctx.activeTab)]: _withCtx(() => [
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_directive_translate, _ctx.translationForTabName(_ctx.activeTab)]
                ]),
                _createVNode(_component_icon_component, {
                  "icon-id": _ctx.IconName.Chevron,
                  class: "a-tabHead__icon"
                }, null, 8, ["icon-id"])
              ]),
              [_ctx.tabPanelSlotName(_ctx.activeTab)]: _withCtx(() => [
                (_ctx.activeTab === _ctx.Tab.Date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", null, [
                          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createTextVNode(" From")
                          ])), [
                            [_directive_translate, { key: _ctx.Translation.Date_from_label}]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(['a-formField', {'active' : !_ctx.hideDatepickerStart}])
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateStart) = $event)),
                              onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleDatepickers('start'))),
                              readonly: _ctx.isMobile,
                              type: "text",
                              class: "a-formInput"
                            }, null, 40, _hoisted_8), [
                              [_vModelText, _ctx.dateStart]
                            ]),
                            _withDirectives(_createElementVNode("div", {
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearDateStart && _ctx.clearDateStart(...args))),
                              class: "a-formField__action"
                            }, [
                              _createVNode(_component_icon_component, {
                                "icon-id": _ctx.IconName.Close
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Close")
                                ]),
                                _: 1
                              }, 8, ["icon-id"])
                            ], 512), [
                              [_vShow, _ctx.dateStart !== null && _ctx.dateStart !== '']
                            ])
                          ], 2)
                        ]),
                        _createElementVNode("label", null, [
                          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _createTextVNode("To")
                          ])), [
                            [_directive_translate, { key: _ctx.Translation.Date_to_label}]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(['a-formField', {'active' : !_ctx.hideDatepickerEnd}])
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateEnd) = $event)),
                              onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleDatepickers('end'))),
                              readonly: _ctx.isMobile,
                              type: "text",
                              class: "a-formInput"
                            }, null, 40, _hoisted_10), [
                              [_vModelText, _ctx.dateEnd]
                            ]),
                            _withDirectives(_createElementVNode("div", {
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clearDateEnd && _ctx.clearDateEnd(...args))),
                              class: "a-formField__action"
                            }, [
                              _createVNode(_component_icon_component, {
                                "icon-id": _ctx.IconName.Close
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Close")
                                ]),
                                _: 1
                              }, 8, ["icon-id"])
                            ], 512), [
                              [_vShow, _ctx.dateEnd !== null && _ctx.dateEnd !== '']
                            ])
                          ], 2)
                        ])
                      ]),
                      _hoisted_11
                    ]))
                  : (_ctx.activeTab === _ctx.Tab.Country)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("ul", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFilters[_ctx.activeTab], (val) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: val,
                              class: "a-filterList__item"
                            }, [
                              _createElementVNode("label", null, [
                                _createVNode(_component_icon_component, {
                                  "icon-id": _ctx.checkboxIcon(_ctx.isValueIncludedIn(_ctx.activeTab, val)),
                                  class: "a-btnIcon"
                                }, null, 8, ["icon-id"]),
                                _createElementVNode("input", {
                                  name: val,
                                  value: val,
                                  checked: _ctx.isValueIncludedIn(_ctx.activeTab, val),
                                  onChange: ($event: any) => (_ctx.handleFilterSelection(val, _ctx.activeTab)),
                                  type: "checkbox"
                                }, null, 40, _hoisted_13),
                                _createElementVNode("span", null, _toDisplayString(_ctx.getFilterName(_ctx.activeTab, val)), 1)
                              ])
                            ]))
                          }), 128))
                        ]),
                        (_ctx.allFilters[_ctx.activeTab].length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _withDirectives(_createElementVNode("span", null, null, 512), [
                                [_directive_translate, { key: _ctx.Translation.No_filters_notice }]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_ctx.activeTab === _ctx.Tab.Category)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("ul", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFilters[_ctx.Tab.MainCategory], (val) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: val,
                                class: "a-filterList__item"
                              }, [
                                _createElementVNode("label", null, [
                                  _createVNode(_component_icon_component, {
                                    "icon-id": _ctx.checkboxIcon(_ctx.isValueIncludedIn(_ctx.Tab.MainCategory, val)),
                                    class: "a-btnIcon"
                                  }, null, 8, ["icon-id"]),
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    name: val,
                                    value: val,
                                    checked: _ctx.isValueIncludedIn(_ctx.Tab.MainCategory, val),
                                    onChange: ($event: any) => (_ctx.handleFilterSelection(val, _ctx.Tab.MainCategory))
                                  }, null, 40, _hoisted_16),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.getFilterName(_ctx.Tab.MainCategory, val)), 1)
                                ])
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFilters[_ctx.Tab.Category], (val) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: val,
                                class: "a-filterList__item"
                              }, [
                                _createElementVNode("label", null, [
                                  _createVNode(_component_icon_component, {
                                    "icon-id": _ctx.checkboxIcon(_ctx.isValueIncludedIn(_ctx.Tab.Category, val)),
                                    class: "a-btnIcon"
                                  }, null, 8, ["icon-id"]),
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    name: val,
                                    value: val,
                                    checked: _ctx.isValueIncludedIn(_ctx.Tab.Category, val),
                                    onChange: ($event: any) => (_ctx.handleFilterSelection(val, _ctx.activeTab))
                                  }, null, 40, _hoisted_17),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.getFilterName(_ctx.Tab.Category, val)), 1)
                                ])
                              ]))
                            }), 128))
                          ]),
                          (_ctx.allFilters[_ctx.activeTab].length === 0 && _ctx.allFilters['mainCategory'].length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _withDirectives(_createElementVNode("span", null, null, 512), [
                                  [_directive_translate, { key: _ctx.Translation.No_filters_notice }]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_ctx.activeTab === _ctx.Tab.City)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (_ctx.allFilters[_ctx.activeTab].length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _withDirectives(_createElementVNode("span", null, null, 512), [
                                    [_directive_translate, { key: _ctx.Translation.No_filters_notice }]
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFilters[_ctx.activeTab], (val) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: val,
                                      class: "a-filterList__item"
                                    }, [
                                      _createElementVNode("label", null, [
                                        _createVNode(_component_icon_component, {
                                          "icon-id": _ctx.checkboxIcon(_ctx.isValueIncludedIn(_ctx.activeTab, val)),
                                          class: "a-btnIcon"
                                        }, null, 8, ["icon-id"]),
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          name: val,
                                          value: val,
                                          checked: _ctx.isValueIncludedIn(_ctx.activeTab, val),
                                          onChange: ($event: any) => (_ctx.handleFilterSelection(val, _ctx.activeTab))
                                        }, null, 40, _hoisted_21),
                                        _createElementVNode("span", null, _toDisplayString(val), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                          ], 64))
                        : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (_ctx.isMobile)
                ? {
                    name: _ctx.tabHeadSlotName(_ctx.modifier),
                    fn: _withCtx(() => []),
                    key: "0"
                  }
                : undefined,
              (!_ctx.isMobile)
                ? {
                    name: _ctx.modifier,
                    fn: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFilters.value, (filter, filterIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter, (filterValue) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: filterValue,
                              onClick: ($event: any) => (_ctx.clearFilter(filterIndex, filterValue)),
                              class: "a-btnSmall -secondary -filtered"
                            }, [
                              _createVNode(_component_icon_component, {
                                "icon-id": _ctx.IconName.Close,
                                class: "a-btnIcon"
                              }, null, 8, ["icon-id"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.getFilterName(filterIndex, filterValue)), 1)
                            ], 8, _hoisted_2))
                          }), 128))
                        ], 64))
                      }), 256)),
                      (_ctx.dateStart || _ctx.dateEnd)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearDates && _ctx.clearDates(...args))),
                            class: "a-btnSmall -secondary -filtered"
                          }, [
                            _createVNode(_component_icon_component, {
                              "icon-id": _ctx.IconName.Close,
                              class: "a-btnIcon"
                            }, null, 8, ["icon-id"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.dateStart) + " - " + _toDisplayString(_ctx.dateEnd), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    key: "1"
                  }
                : undefined,
              (_ctx.isMobile)
                ? {
                    name: _ctx.tabPanelSlotName(_ctx.modifier),
                    fn: _withCtx(() => [
                      _withDirectives(_createElementVNode("span", _hoisted_3, null, 512), [
                        [_directive_translate, { key: _ctx.Translation.Filter_by}]
                      ]),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFilters.value, (filter, filterIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter, (filterValue) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: filterValue,
                                onClick: ($event: any) => (_ctx.clearFilter(filterIndex, filterValue)),
                                class: "a-btnSmall -secondary -filtered"
                              }, [
                                _createVNode(_component_icon_component, {
                                  "icon-id": _ctx.IconName.Close,
                                  class: "a-btnIcon"
                                }, null, 8, ["icon-id"]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.getFilterName(filterIndex, filterValue)), 1)
                              ], 8, _hoisted_4))
                            }), 128))
                          ], 64))
                        }), 256)),
                        (_ctx.dateStart || _ctx.dateEnd)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearDates && _ctx.clearDates(...args))),
                              class: "a-btnSmall -secondary -filtered"
                            }, [
                              _createVNode(_component_icon_component, {
                                "icon-id": _ctx.IconName.Close,
                                class: "a-btnIcon"
                              }, null, 8, ["icon-id"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.dateStart) + " - " + _toDisplayString(_ctx.dateEnd), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    key: "2"
                  }
                : undefined,
              (_ctx.isMobile)
                ? {
                    name: _ctx.tabPanelBtnSlotName(_ctx.modifier),
                    fn: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "a-btnCta -action",
                        "aria-label": "Close modal",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeAndSave && _ctx.closeAndSave(...args)))
                      }, [
                        _withDirectives(_createElementVNode("span", null, null, 512), [
                          [_directive_translate, { key: _ctx.Translation.Search_submit}]
                        ])
                      ])
                    ]),
                    key: "3"
                  }
                : undefined
            ]), 1032, ["tabs", "initialTab", "modifier", "onCloseAndSave", "onTabSwitched", "onActiveTabChange"])
          ]),
          footer: _withCtx(() => [
            _withDirectives(_createVNode(_component_SpinnerComponent, {
              class: "-inline",
              label: ""
            }, null, 512), [
              [_vShow, _ctx.isLoading]
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeAndSave && _ctx.closeAndSave(...args))),
              class: "a-btnCta -action",
              "aria-label": "Close modal"
            }, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_translate, { key: _ctx.Translation.Search_submit }]
              ])
            ])
          ]),
          _: 1
        }, 8, ["onCloseModal"])), [
          [_vShow, _ctx.isModalVisible]
        ])
      : _createCommentVNode("", true)
  ]))
}